var _rect, _rect2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPlaceholderHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 264,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 160,
    fill: "#FDF4F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 262,
    height: 158,
    fill: "none",
    stroke: "#EF8E92",
    strokeWidth: 1,
    strokeDasharray: "5,5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 132,
    y: 74,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Bogle,Arial,sans-serif",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#DE1C24"
  }, "Replace with an image.")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 132,
    y: 94,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Bogle,Arial,sans-serif",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#DE1C24"
  }, "(Max resolution: 528 x 320px)")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholderHalf);
export default __webpack_public_path__ + "static/media/img-placeholder-half.1cfdcd66184639453a98555c53c905cf.svg";
export { ForwardRef as ReactComponent };